<template>
    <div class="inspiring">
        <div class="loading-full-page" v-if="isLoadingPage">
            <b-card>
                <b-skeleton animation="wave" width="85%"></b-skeleton>
                <b-skeleton animation="wave" width="55%"></b-skeleton>
                <b-skeleton animation="wave" width="70%"></b-skeleton>
            </b-card>
        </div>
        <template v-else>
            <h1 class="inspiring__title">{{getTranslatedText("congratulations")}}!</h1>
            <p class="inspiring__description">
                {{getTranslatedText("your transaction was successful with transaction id: [transaction_id]", {
                    transaction_id: transactionId
                })}}
            </p>
            <div class="inspiring__items">
                 <div v-for="(item, index) in listTickets" :key="index" class="inspiring__item">
                     <div class="inspiring__item-left">
                         <div class="inspiring__item-title">
                             {{ getTranslatedText("your numbers are") }}
                         </div>
                         <div class="inspiring__item-content">
                             <div class="inspiring__item-content-name">{{ renderTitleTicket(item.name) }}</div>
                             <div class="inspiring__item-content-numbers">
                                 <div v-for="(number, index) in item.balls" :key="index" :class="`inspiring__item-content-number ${renderClass(number, index)}`">
                                     <div class="inspiring__item-content-box-number">
                                         <a>{{ renderNumberLocale(number) }}</a>
                                     </div>
                                 </div>
                             </div>
                         </div>
                         <div class="inspiring__item-drawdate">
                             <span>{{ getTranslatedText("draw date") }}:</span>
                             {{ item.date }}
                         </div>
                     </div>
                     <div class="inspiring__item-right">
                         <div class="inspiring__item-raffle-left">
                            <span class="show-desktop">{{getTranslatedText("raffle id")}}</span>
                            <img class="show-mobile" src="@/assets/images/tickets/phone-mb.png" />
                         </div>
                         <div class="inspiring__item-raffle-id">
                             <div class="inspiring__item-raffle-id-image show-desktop">
                                <img src="@/assets/images/tickets/mobile-screen.png" />
                             </div>
                             <span class="inspiring__item-raffle-id show-mobile">{{getTranslatedText("raffle id")}}</span>
                             <span class="inspiring__item-raffle-id-value">{{ item.raffle_id || getTranslatedText("Pending Generation")}}</span>
                             <div class="inspiring__item-download-certificate show-mobile" @click="item.link_certificate && !isLoadingDownload && downloadFile(link_certificate)">
                                <b-spinner v-if="isLoadingDownload" variant="success" />
                                <span>{{ item.link_certificate ? getTranslatedText("download green certificate") : getTranslatedText('generating certificate') }}</span>
                                <img v-if="item.link_certificate" src="@/assets/images/inspiring/download.png" />
                             </div>
                         </div>
                     </div>
                 </div>
            </div>
            <div class="inspiring__purchase">
                <h1 class="inspiring__purchase-title">{{getTranslatedText("thank you for your purchase")}}</h1>
                <div class="inspiring__purchase-description">{{getTranslatedText("each green certificate you buy is your contribution to the oasis park that will help us strengthen efforts reducing the human carbon footprint around the world and in making oman more sustainable")}}</div>
            </div>
            <div class="inspiring__download" @click="handleDownload">
                {{getTranslatedText("download your green certificates to find your raffle ids")}}
            </div>
            <div class="inspiring__countdown">
                <CountDownTimer :nextDrawDate="nextDrawFormat" :isShowBgrImage="true" :date="renderDate()" />
            </div>
            <ButtonCustom
                classBtn="inspiring__button"
                classOption="btn-radius"
                typeBtn="primary"
                type="primary"
                text="buy more green certificates"
                @onClickButton="onBuyMore"
            />
        </template>
    </div>
</template>
<script>
import toolService from '@/services/tool.service';
import gameService from '@/services/game.service';
import languageMixin from "@/mixins/language/language-mixin";
import ButtonCustom from "@/components/common/button";
import CountDownTimer from "@/components/common/count-down-timer/CountDownTimer";

import moment from "moment";

import { isArrayEmpty, isStrEmpty, renderClassBall, renderLocaleNumber } from '@/components/common/utils';

export default {
    mixins: [languageMixin],
    components: {
        CountDownTimer,
        ButtonCustom
    },
    data() {
        return {
            listTickets: [],
            maxiumBlue: 0,
            maxiumGreen: 0,
            minimumBall: 0,
            isLoadingPage: true,
            isLoadingDownload: false,
            nextDraw: "",
            nextDrawFormat: "",
            transactionId: "",
            scriptEle: '',
        };
    },
    created() {
        const parameters = this.$route.query;
        if(parameters?.reference) {
            this.fetchData(parameters.reference)
        } else {
            this.$router.push("/home");
        }
    },
    methods: {
        async fetchData(reference) {
            try {
                const resp = await gameService.getReference(reference)
                const respValidate = await toolService.getValidateTicket();
                const respNextLive = await gameService.getTimeNextLive()
                if(resp.status === 200) {

                  let snippetScript = document.createElement('script')
                  snippetScript.setAttribute('src', '(function(a,b,c,d,e){var f=d.getDate().toString()+d.getMonth().toString()+d.getFullYear().toString(),g=b.createElement(c);g.type="text/javascript",g.async=1,g.setAttribute("data-script-id","jb-leads-code"),g.src="https://static.jubnaadserve.com/api/conversion/js/"+e+"?jcv="+f,document.getElementsByTagName("head")[0].appendChild(g)})(window,document,"script",new Date,19875);')
                  this.scriptEle = document.head.appendChild(snippetScript)

                    if(respNextLive.status === 200) {
                        this.nextDraw = moment(respNextLive.data.cutoff)
                        this.nextDrawFormat =  moment(respNextLive.data.cutoff).format('dddd, DD MMMM yyyy')
                    }

                    let listTransactions = resp.data.transactions.map((item, index) => {
                        let balls = [];
                        if (!isArrayEmpty(item.bets.bets)) {
                            item.bets.bets.map((x) => {
                                balls = balls.concat(x);
                            });
                        }

                        let date = moment(item.date).format("DD/MM/YYYY");

                        return {
                            id: item.id,
                            name: `entry ${index + 1}`,
                            balls,
                            date,
                            raffle_id: item.raffle_id
                        };
                    });

                    this.listTickets = listTransactions
                    this.transactionId = resp.data.transactions[0]?.transaction_id
                    this.maxiumBlue = respValidate.maxiumBlue;
                    this.maxiumGreen = respValidate.maxiumGreen;
                    this.minimumBall = respValidate.minMaxTickets[0];
                    this.isLoadingPage = false;
                }
            } catch (err) {
                console.log(err, "err");
            }

        },

        renderClass(number, index) {
            return renderClassBall(
                number,
                index,
                this.minimumBall,
                this.maxiumBlue,
                this.maxiumGreen
            );
        },

        renderNumberLocale(number) {
            return renderLocaleNumber(number);
        },

        renderDate() {
            moment.locale("en");

            if (!isStrEmpty(this.nextDraw)) {
                return moment.utc(this.nextDraw).format(
                     "DD-MM-YYYY HH:mm:ss +00:00"
                );
            }
        },

        onBuyMore() {
            this.$router.push('/buy/green-certificates')
        },

        handleDownload() {
            this.$router.push("/favourite");
        },

        renderTitleTicket(text) {
            let textLowercase = text.toLowerCase();
            let number = textLowercase.split(" ")[1];
            textLowercase = textLowercase.replaceAll(
                "entry",
                this.getTranslatedText("entry")
            );
            textLowercase = textLowercase.replaceAll(
                number,
                renderLocaleNumber(parseInt(number))
            );
            return textLowercase;
        },

        downloadFile(url ) {
            this.isLoadingDownload = true
            window.open(url, "_blank")
            setTimeout(() => {
                this.isLoadingDownload = false
            }, 2000);
        },
    },
    beforeDestroy() {
      document.head.removeChild(this.scriptEle);
    }
};
// Taboola Pixel Code
_tfa.push({notify: 'event', name: 'lead', id: 1479600});
// End of Taboola Pixel Code
</script>



<style scoped lang="scss" src="@/assets/scss/mobile/inspiring/inspiring.scss" />
